import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { JSX } from 'react';
import { QuoteItem, QuoteStatus } from '../../common/types/quotes';

/**
 * Cell renderer for FNA description
 */
const QuoteStatusCell = ({ row }: { row: QuoteItem }): JSX.Element => (
  <Box>
    {row.statusID === QuoteStatus.Quoted && (
      <Box className="flex space-x-2" color="success.main">
        <Icon width={22} icon="ic:baseline-check-circle" />
        <Typography color="text.primary">Quoted</Typography>
      </Box>
    )}
    {row.statusID === QuoteStatus.CanQuote && (
      <Box className="flex space-x-2" color="success.main">
        <Icon width={22} icon="ic:baseline-check-circle" />
        <Typography color="text.primary">Can quote</Typography>
      </Box>
    )}
    {row.statusID === QuoteStatus.Invalid && (
      <Tooltip title="Client profile is incomplete" placement="left">
        <Box className="flex space-x-2" color="warning.main">
          <Icon width={22} icon="ic:baseline-info" />
          <Typography color="text.primary">Can’t quote</Typography>
        </Box>
      </Tooltip>
    )}
    {row.statusID === QuoteStatus.Failed && (
      <Box className="flex space-x-2" color="error.main">
        <Icon width={22} icon="ic:baseline-error" />
        <Typography color="text.primary">Failed</Typography>
      </Box>
    )}
    {row.statusID === QuoteStatus.Incomplete && <CircularProgress />}
  </Box>
);

export default QuoteStatusCell;
